import { TIER_TYPES } from "./tierTypes";
const OPTIONAL_KEYS = ["tierType"];

export default parseDiscountMessage = (discountMessage) => {
  try {
    const parsers = [
      {
        key: "bundleTitle",
        parser: (value) => value,
      },
      {
        key: "message",
        parser: (value) => value,
      },
      {
        key: "successMessage",
        parser: (value) => value,
      },
      {
        key: "minimumQuantityTiers",
        parser: (value) => JSON.parse(value),
      },
      {
        key: "percentageOffTiers",
        parser: (value) => JSON.parse(value).map((tier) => parseFloat(tier)),
      },
      {
        key: "tierType",
        parser: (value) =>
          value in TIER_TYPES ? TIER_TYPES[value] : TIER_TYPES.Quantity,
      },
    ];

    const parsedData = {};

    parsers.forEach(({ key, parser }) => {
      if (!discountMessage[key] && !OPTIONAL_KEYS.includes(key))
        throw new Error(`Missing discountMessage ${key}`);

      parsedData[key] = parser(discountMessage[key]);
    });

    return parsedData;
  } catch (error) {
    // console.warn(error);
    return null;
  }
};
